import React from 'react'
import useConfig from '../hooks/useConfig'
//import logoSvgRaw from '../assets/logo.svg?raw'
import './BuildInfoFooter.css'

export default function BuildInfoFooter(): JSX.Element {
  const version = useConfig<string>('version') ?? 'dev'
  const commitHash = useConfig<string>('commitHash') ?? 'unknown'
  const buildTime = useConfig<string>('buildTimeHuman') ?? '—'

  return (
    <footer className="build-info-footer">
      <div className="build-info-left">
        <a href="https://prostep.com" className="brand-info-link" target="_blank" rel="noopener noreferrer">
          {/* <span
            className="brand-logo"
            aria-label="Logo"
            role="img"
            dangerouslySetInnerHTML={{ __html: logoSvgRaw }}
          /> */}
        </a>
      </div>
      <div className="build-info-right">
        <span className="build-info-item invisible" title={commitHash}>
          commit&nbsp;{commitHash.slice(0, 7)}
        </span>
        <span className="build-info-separator invisible">·</span>
        <span className="build-info-item invisible">built&nbsp;{buildTime}</span>
        <span className="build-info-separator invisible">·</span>
        <span className="build-info-item">v{version}</span>
      </div>
    </footer>
  )
}
